import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './hooks/useAuth'
import { useUserRole } from './hooks/useUserRole'
import LeadershipDashboard from './pages/LeadershipDashboard'
import CompanyDashboard from './pages/CompanyDashboard'
import AdminUsers from './pages/AdminUsers'
import Login from './pages/Login'
import StrategyReentry from './pages/StrategyReentry'

// JIT user provisioning - creates DB record on first authenticated login
// (Authorization uses Cognito groups, this just ensures DB tracking)
function UserProvisioning() {
  useUserRole()
  return null
}

function App() {
  const { isAuthenticated, isLoading, groups } = useAuth()

  if (isLoading) {
    return <div className="loading">Loading...</div>
  }

  // Authorization derived from Cognito groups (single source of truth)
  const isAdmin = groups.includes('admin')
  const hasLeadershipAccess = groups.includes('admin') || groups.includes('leadership')
  const defaultRoute = hasLeadershipAccess ? '/leadership' : '/company'

  return (
    <div className="app">
      {isAuthenticated && <UserProvisioning />}
      <Routes>
        <Route
          path="/"
          element={
            isAuthenticated ? (
              <Navigate to={defaultRoute} replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/admin/users"
          element={
            isAuthenticated && isAdmin ? (
              <AdminUsers />
            ) : isAuthenticated ? (
              <Navigate to={defaultRoute} replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/leadership"
          element={
            isAuthenticated && hasLeadershipAccess ? (
              <LeadershipDashboard />
            ) : isAuthenticated ? (
              <Navigate to="/company" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/company"
          element={
            isAuthenticated ? <CompanyDashboard /> : <Navigate to="/login" replace />
          }
        />
        {/* Expired/missing signed cookie: CloudFront's 403 fallback serves
            this SPA for strategy URLs. Re-mint and bounce back. */}
        <Route
          path="/strategy/*"
          element={
            isAuthenticated ? <StrategyReentry /> : <Navigate to="/login" replace />
          }
        />
        <Route
          path="/login"
          element={
            isAuthenticated ? <Navigate to={defaultRoute} replace /> : <Login />
          }
        />
      </Routes>
    </div>
  )
}

export default App
